import { render, staticRenderFns } from "./ElementLowerThird.vue?vue&type=template&id=42236fe2&"
import script from "./ElementLowerThird.vue?vue&type=script&lang=js&"
export * from "./ElementLowerThird.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports